export default __webpack_public_path__ + "img/3af2a547027d409a800279e3af887a95.png";